<template>
    <LayoutDefault variant="white">
        <div>
            <OrganismPageHeader :title="$t('pages.about')"
                                background-image="../../../img/static/IMG_0362_BANNER.jpg"/>

            <div class="legacy">
                <main class="main-container static-page m-0 pt-10">
                    <div class="container-fluid__with-padding-x description">
                        <div class="separator">{{ $t('about.philosophy.title') }}</div>
                    </div>
                    <div class="container-fluid__with-padding description">
                        <div class="row justify-content-center">
                            <div class="col-lg-6 col-md-8 col-12">
                                <p v-html="$t('about.philosophy.quote')"></p>
                                <p v-html="$t('about.philosophy.content')"></p>
                            </div>
                        </div>
                    </div>
                    <div class="container-fluid__with-padding-x description">
                        <div class="separator">{{ $t('about.mission.title') }}</div>
                    </div>
                    <div class="container-fluid__with-padding description">
                        <h1 class="title text-center margin_bottom_60">{{ $t('about.mission.section') }}</h1>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <p class="margin_bottom_60">{{ $t('about.mission.foundation.content') }}</p>
                            </div>
                            <div class="col-12 col-md-6">
                                <p class="margin_bottom_60">{{ $t('about.mission.transdisciplinary.content') }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="container-fluid__with-padding description">
                        <div class="row">
                            <div class="col-md-6 col-12">
                                <h1 class="title text-center margin_bottom_60" v-html="$t('about.lab_geneva.title')"></h1>
                                <p v-html="$t('about.lab_geneva.content_1')"></p>
                                <p>{{ $t('about.lab_geneva.content_2') }}</p>
                                <p>{{ $t('about.lab_geneva.content_3') }}</p>
                            </div>
                            <div class="col-md-6 col-12">
                                <h1 class="title text-center margin_bottom_60" v-html="$t('about.lab_athens.title')"></h1>
                                <p>{{ $t('about.lab_athens.content') }}</p>
                                <p>{{ $t('about.lab_athens.content_2') }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="container-fluid description">
                        <VueSlickCarousel v-bind="settingsSlider">

                            <Slide class="img__container"
                                   image="../../img/static/IMG_0362.jpg"
                                   :title="$t('about.images.img_1')"
                                   :description="$t('about.images.img_1')"/>
                            <Slide class="img__container"
                                   image="../../img/static/IMG_0367.jpg"
                                   :title="$t('about.images.img_2')"
                                   :description="$t('about.images.img_2')"/>
                            <Slide class="img__container"
                                   image="../../img/static/IMG_0440.jpg"
                                   :title="$t('about.images.img_3')"
                                   :description="$t('about.images.img_3')"/>
                            <Slide class="img__container"
                                   image="../../img/static/_MG_2735.jpg"
                                   :title="$t('about.images.img_4')"
                                   :credit="$t('about.images.credit_2')"
                                   :description="$t('about.images.img_4')"/>
                            <Slide class="img__container"
                                   image="../../img/static/_MG_2752.jpg"
                                   :title="$t('about.images.img_5')"
                                   :credit="$t('about.images.credit_2')"
                                   :description="$t('about.images.img_5')"/>

                            <template #prevArrow="arrowOption">
                                <div class="custom-arrow-left">
                                    <div class="slick-button">
                                        <chevron-left-icon :size="32"></chevron-left-icon>
                                    </div>
                                </div>
                            </template>
                            <template #nextArrow="arrowOption">
                                <div class="custom-arrow-right">
                                    <div class="slick-button">
                                        <chevron-right-icon :size="32"></chevron-right-icon>
                                    </div>
                                </div>
                            </template>
                        </VueSlickCarousel>
                    </div>

                    <div class="container-fluid__with-padding-x description">
                        <div class="separator">{{ $t('about.history.title') }}</div>
                    </div>
                    <div class="container-fluid__with-padding description">
                        <div class="row">
                            <div class="col-md-6 col-12">
                                <p>{{ $t('about.history.content_1.year') }}</p>
                                <p class="margin_bottom_60">{{ $t('about.history.content_1.content') }}</p>

                                <p>{{ $t('about.history.content_2.year') }}</p>
                                <p>{{ $t('about.history.content_2.content') }}</p>
                                <p class="margin_bottom_60">{{ $t('about.history.content_2.content_2') }}</p>

                                <p>{{ $t('about.history.content_3.year') }}</p>
                                <p class="margin_bottom_60">{{ $t('about.history.content_3.content') }}</p>

                                <p>{{ $t('about.history.content_4.year') }}</p>
                                <p class="margin_bottom_60">{{ $t('about.history.content_4.content') }}</p>
                            </div>
                            <div class="col-md-6 col-12">
                                <p>{{ $t('about.history.content_5.year') }}</p>
                                <p class="margin_bottom_60">{{ $t('about.history.content_5.content') }}</p>

                                <p>{{ $t('about.history.content_6.year') }}</p>
                                <p class="margin_bottom_60">{{ $t('about.history.content_6.content') }}</p>

                                <p>{{ $t('about.history.content_7.year') }}</p>
                                <p class="margin_bottom_60">{{ $t('about.history.content_7.content') }}</p>

                                <p>{{ $t('about.history.content_8.year') }}</p>
                                <p class="margin_bottom_60">{{ $t('about.history.content_8.content') }}</p>

                                <p>{{ $t('about.history.content_9.year') }}</p>
                                <p class="margin_bottom_60">{{ $t('about.history.content_9.content') }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="container-fluid__with-padding-x description">
                        <div class="separator">{{ $t('about.press.title') }}</div>
                    </div>
                    <div class="container-fluid__with-padding description">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <a target="_blank" href="../../pdf/Prestige_Immobilier_06.2007.pdf">Flux Laboratory: Et si l'on
                                    mettait en scène...la vie? - Prestige Immobilier/n°8/2007</a><br>
                                <a target="_blank" href="../../pdf/LeTemps_Cynthia_Odier_entre_deux_mondes.pdf">Cynthia Odier
                                    entre deux mondes - Le Temps/13.01.2007</a><br>
                                <a target="_blank"
                                   href="../../pdf/Article_LeTemps_25.07.09_Cynthia Odier au nom de la danse.pdf">Cynthia Odier
                                    au nom de la danse - Le Temps/25.07.2009</a><br>
                                <a target="_blank"
                                   href="../../pdf/Article_LeTemps_25.07.09_Je sers de pont entre l'art et le business.pdf">Je
                                    sers de pont entre l'art et le business - Le Temps/25.07.2009</a>
                            </div>
                            <div class="col-12 col-md-6">
                                <a target="_blank" href="../../pdf/JeVeuxQue_Le_Temps_29.09.12.pdf">Je veux que la danse soit
                                    partout - Le Temps/29.09.2012</a><br>
                                <a target="_blank" href="../../pdf/DerBund_Cynthia Odier_2013.pdf">Interview avec Cynthia Odier
                                    - Der Bund/11.05.2013</a><br>
                                <a target="_blank" href="../../pdf/WomenInBusiness_2013.pdf">Interview Cynthia Odier - Women in
                                    Business/Juin 2013</a><br>
                                <a target="_blank" href="../../pdf/powerwomen-officiel-p.2.pdf">Power Women - Cynthia Odier -
                                    L'Officiel Suisse/sept. 2015</a>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    </LayoutDefault>
</template>

<script>
import DarkMode from "../mixins/dark-mode";
import UpdateTitle from "../mixins/update-title";
import Header from "../components/legacy/PageDetail/Header";
import VueSlickCarousel from "vue-slick-carousel";
import Slide from "../components/legacy/PageDetail/Slide";
import ChevronLeftIcon from "vue-material-design-icons/ChevronLeft";
import ChevronRightIcon from "vue-material-design-icons/ChevronRight";
import Reset from "../mixins/reset";
import OrganismPageHeader from "../components/global/organisms/OrganismPageHeader.vue";
import LayoutDefault from "../layouts/LayoutDefault.vue";

export default {
    name: "PageAbout",
    components: {
        LayoutDefault,
        OrganismPageHeader,
        Header,
        VueSlickCarousel,
        Slide,
        ChevronLeftIcon,
        ChevronRightIcon,
    },
    mixins: [DarkMode, UpdateTitle, Reset],
    data: () => {
        return {
            currentLang: 'fr',
            settingsSlider: {
                dots: true,
                infinite: true,
                centerMode: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                initialSlide: 0,
                centerPadding: "0px",
                autoplay: true,
                autoplaySpeed: 5000,
                pauseOnFocus: true,
                swipeToSlide: true,
                variableWidth: true,
                draggable: true,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            initialSlide: 1,
                            variableWidth: true,
                            centerMode: true,
                            adaptiveHeight: false
                        }
                    }
                ]

            }
        }
    },
    mounted() {
        this.currentLang = this.$i18n.locale;
    }
}
</script>

<style scoped>

</style>


